// Generated by CoffeeScript 2.7.0
var AMOUNT_OPTIONS, EditRedPacketQuotasModal;

AMOUNT_OPTIONS = ['increase_amount', 'decrease_amount'];

import EditOption from 'trunks/vue/admin/components/settings/settings_red_packet_quotas/edit_option.js';

import RedPacketQuotasMixin from 'trunks/vue/admin/components/settings/settings_red_packet_quotas/mixin.js';

export default EditRedPacketQuotasModal = Vue.extend({
  mixins: [RedPacketQuotasMixin],
  components: {
    'edit-option': EditOption
  },
  props: {
    callback: {
      type: Function
    }
  },
  data: function() {
    return {
      amountOptions: this._generateAmountOptions(),
      allocatedAmount: '',
      remark: '',
      allocatedAmountValid: true
    };
  },
  template: `<modal title='详情' extendClass="show-red-packet-quotas-modal edit-red-packet-quotas-modal" ref="modal">
  <div class="modal-body">
    <template v-for="group in groups">
      <div class="group">
        <div class="group-title">{{ group.title }}</div>
        <div class="group-content">
          <template v-for="(item, key) in group.option">
            <div class="item">
              <div class="header">{{ item }}</div>
              <div class="value" v-if="key == 'name'">
                <user-item :user="redPacketQuotas.user"/>
              </div>
              <div class="slp-tooltip top" :data-title="redPacketQuotas[key]" v-else>
                <div class="value text-ellipsis">{{ redPacketQuotas[key] }}</div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </template>
    <div class="group">
      <div class="form-field required" :class="{'has-error': !allocatedAmountValid }">
        <div class="form-field-head">
          <div class="form-field-title">额度修改</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <edit-option  optionsClass="amount-option"
                          :initialValue="statusOption"
                          :options="amountOptions"
                          :canCancelSingleSelect="false"
                          @valueChange="onOptionValueChangeFunc"
                          ref="optionRef" />
          </div>
        </div>
      </div>
    </div>
    <div class="group">
      <div class="form-field">
        <div class="form-field-head">
          <div class="form-field-title">备注</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <input class="form-field-value" type="text" v-model.trim="remark">
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer" slot="footer">
    <button class="outlined btn-default" @click='close'>取消</button>
    <button @click='ensure'>确定</button>
  </div>
</modal>`,
  computed: {
    statusOption: function() {
      return _.first(this.amountOptions);
    }
  },
  methods: {
    close: function() {
      return this.$refs.modal.close();
    },
    ensure: function() {
      var data;
      this.$refs.optionRef.validate();
      this._validate();
      if (!this.allocatedAmountValid) {
        return;
      }
      data = {
        red_packet_allocation: {
          allocated_amount: this.allocatedAmount,
          remark: this.remark,
          user_id: this.initialRedPacketQuotas.user.id
        }
      };
      return Skylark.Libs.Ajax.post(Skylark.Helpers.UrlHelper.adminUrlFor("/settings/red_packet_allocations"), {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: data,
        success: (data) => {
          Skylark.Bridge.newAlertify('操作成功', {
            type: 'success'
          });
          this.callback();
          return this.close();
        },
        error: function() {
          return Skylark.Bridge.newAlertify('操作失败，请重试', {
            type: 'error'
          });
        }
      });
    },
    onOptionValueChangeFunc: function(option, value) {
      this.allocatedAmount = value;
      return this._parseAllocatedAmlount(option, value);
    },
    _generateAmountOptions: function() {
      return _.map(AMOUNT_OPTIONS, function(option_id) {
        return new Skylark.App.Model.FieldOption({
          id: option_id,
          value: Skylark.Helpers.translate("settings.allocated_amount." + option_id)
        });
      });
    },
    _parseAllocatedAmlount: function(option, value) {
      if (option.id === 'increase_amount') {
        return this.allocatedAmount = value;
      } else {
        return this.allocatedAmount = -value;
      }
    },
    _validate: function() {
      return this.allocatedAmountValid = !Math.abs(this.allocatedAmount) ? false : true;
    }
  }
});
